import * as React from "react"
import { CollectionCard } from "./collection-card"
import { listingContainerStyle } from "./product-listing.module.css"

// To optimize LCP we mark the first product card as eager so the image gets loaded faster
export function CollectionListing({ products = [] }) {
  return (
    <div className={listingContainerStyle}>
      {products.map((p, index) => (
        <CollectionCard product={p} key={p.id} eager={index === 0} />
      ))}
    </div>
  )
}
